namespace SorAraBul.Administration {

    @Serenity.Decorators.registerClass()
    export class PlanPage {

        constructor() {
            this.bindEvents();
        }

        private bindEvents(): void {
            // Satın Al butonları
            $('.satın-al').on('click', (e) => {
                e.preventDefault();

                const target = $(e.currentTarget);
                const packageId = Q.toId(target.data('package-id'));

                if (!packageId) {
                    Q.notifyError('Geçersiz paket seçimi!');
                    return;
                }

                window.location.href = `/credit-purchase/payment?packageId=${packageId}`;
            });

            // İletişim butonu
            $('.iletisim').on('click', (e) => {
                e.preventDefault();
                Q.notifyInfo('İletişim formuna yönlendiriliyorsunuz...');
                window.location.href = "/iletisim";
            });
        }

    }
}
